export default {
  path: '/contacts',
  name: 'contacts',
  component: () => import('../components/contact/Layout'),
  redirect: { name: 'ContactList' },
  meta: {
    breadcrumb: 'contact.contacts',
  },
  children: [
    {
      name: 'ContactList',
      path: '',
      component: () => import('../views/contact/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ContactCreate',
      path: 'new',
      component: () => import('../views/contact/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ContactUpdate',
      path: ':id/edit',
      component: () => import('../views/contact/Update'),
      meta: {
        breadcrumb: 'contact.contact',
      },
    },
    {
      name: 'ContactShow',
      path: ':id',
      component: () => import('../views/contact/Show'),
      meta: {
        breadcrumb: 'contact.contact',
      },
    }
  ]
};
